//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {
    'use strict';

    angular.module('container.widgets')
        .directive('srsngHint', srsngHint);

    function srsngHint() {
        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/hint/hint.html',
            scope: {
                message: '@'
            },
            controller: controller

        };

        function controller($scope, $timeout) {
            $scope.iconURL = "/container/ui/assets/img/icons/system-icons-16x16/system-ic-hint-16x16.svg";
            $scope.iconColor = "icon-hide";
            $scope.scopeId = $scope.$id;
            $scope.popupVisible = false;

            $scope.showPopup = showPopup;
            $scope.hidePopup = hidePopup;

            function showPopup() {
                $timeout(function () {
                    $scope.popupVisible = $scope.message.length > 0;
                    if ($scope.popupVisible)
                        $scope.iconColor = "icon-show";
                });
                setTimeout(function () {
                    hidePopup();
                }, 30000);
            }

            function hidePopup() {
                $scope.iconColor = "icon-hide";
                $scope.popupVisible = false;
            }
        }
    }

})();

